<template>
  <v-card-text>
    <v-switch
      :label="`${$t('schema.builder.inputs.options.required')}`"
      :input-value="options.required"
      @change="update({required: $event})"
    ></v-switch>
  </v-card-text>
</template>
<script>
import options from "@/mixins/options"

export default {
  name: "date-options",
  mixins: [ options ]
}
</script>
<style>
</style>
